import React, { useEffect, useState } from "react"
import MDButton from "components/MDButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Grid } from "@mui/material";
import "./GuestPopUp.css";
import EditDueAmount from "./EditDueAmount";
import Emodal1 from "./Emodal1";
// import EditGuestDetailsScreen from "../EditGuestDetails";
import EditGuestForm from "./EditGuestForm";
import ForceCheckoutReason from "./ForceCheckoutReason";
import ChangeBed from "./ChangeBed";
import Prebook from "./Prebook";
import CancelCheckout from "./CancelCheckout";
import ExtenPlanForRegularAndMonthlyAsDaily from "./ExtendPlanForRegularOrMonthlyAsDaily";
export default function EditGuestPopUp(props) {
  const data =
    props.type === "exceedDue"
      ? "Plan Extension Of Guest"
      : props.type === "forcecheck"
      ? "Guest CheckOut"
      : props.type === "bed"
      ? "Change Bed"
      :props.type === "preebooking"
      ? "Pree Booking"
      : props.type === "editDue"
      ? "Edit Due Amount"
      : props.type === "cancelCheckout"
      ? "Cancel Checkout"
      :props.type === "editGuest" ?
       "Edit Guest Details"
      :props.type === "extendPlanforRegulatAndMonthlyAsDaily" ?
       "Extend RegularMonthly To Daily ":null
  return (
    <div>
      <Dialog
        open={props.showEditGuest}
        onClose={props.editGuestHandler}
        maxWidth="lg"
      >
        <MDButton
          width="20%"
          variant="contained"
          color="info"
          size="large"
          justify="center"
          style={{ borderRadius: 0 }}
        >
          {data}
        </MDButton>
        <DialogContent>
          {props.type === "exceedDue" ? (
            <Emodal1
              guestdetails={props.guestdetails}
              editGuestHandler={props.editGuestHandler}
              handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}
            />
          ) : props.type === "forcecheck" ? (
            <ForceCheckoutReason
              guestdetails={props.guestdetails}
              editGuestHandler={props.editGuestHandler}
              handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}
            />
          ) : props.type === "bed" ? (
            <ChangeBed
              guestdetails={props.guestdetails}
              editGuestHandler={props.editGuestHandler}
              handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}
            />
          ) : props.type === "editDue" ? (
            <EditDueAmount
              guestdetails={props.guestdetails}
              handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}
              editGuestHandler={props.editGuestHandler}
            />
          ) : props.type === "cancelCheckout" ? (
            <CancelCheckout
              guestdetails={props.guestdetails}
              editGuestHandler={props.editGuestHandler}
              handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}
            />
          ) : props.type === "editGuest"? (
            <EditGuestForm
              guestdetails={props.guestdetails}
              editGuestHandler={props.editGuestHandler}
              handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}
            />
          ):props.type ==="preebooking"?(
            <Prebook guestdetails={props.guestdetails}
            editGuestHandler={props.editGuestHandler}
            handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}/>
          ):props.type ==="extendPlanforRegulatAndMonthlyAsDaily"?(
            <ExtenPlanForRegularAndMonthlyAsDaily guestdetails={props.guestdetails}
            editGuestHandler={props.editGuestHandler}
            handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}/>
          ):
          null}
        </DialogContent>
        <DialogActions>
          <Grid container style={{ display: "flex" }}>
            <Grid item xs={6}>
              <MDButton
                width="20%"
                variant="contained"
                color="info"
                size="large"
                justify="center"
                style={{ borderRadius: 10 }}
                onClick={props.editGuestHandler}
              >
                Close
              </MDButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
